// Direktlink `?zertifikat=<id>` auf „Meine Zertifikate“ in der neuen Ansicht (Sitzung A, §9k.4).
//
// In der neuen Ansicht läuft `StudentCertificates` unter der neuen Seite weiter. `StudentLayout`
// zeigt bei jedem Seitenwechsel erst die Anmeldeprüfung; in dieser Zeit findet die alte Seite das
// Zertifikat in ihrer Liste und entfernt den Parameter, bevor die neue Seite eingehängt ist. Der
// Glückwunschdialog nach der Prüfung und die Lernreise öffneten deshalb nie das Blatt.
// `useNeueAnsicht` liest die Adresse schon im ersten Rendern von `StudentLayout` und merkt sich
// den Link hier (unabhängig von der Wahl, weil das Konto dann noch unbekannt ist; nie in einer
// Übernahme; ohne Abfrage). Gelesen wird er nur von der neuen Seite.
// Liegt über den Hook im Hauptpaket, deshalb ohne Importe.

let gemerkt: string | null = null;

/** Das Zertifikat aus `?zertifikat=`, nur auf einer Adresse, die auf `/zertifikate` endet. */
export function zertifikatAusAdresse(pfad: string, suche: string): string | null {
  if (!/\/zertifikate\/?$/.test(pfad)) return null;
  return new URLSearchParams(suche).get("zertifikat") || null;
}

export function zertifikatLinkMerken(pfad: string, suche: string): void {
  const id = zertifikatAusAdresse(pfad, suche);
  if (id) gemerkt = id;
}

export function gemerkterZertifikatLink(): string | null {
  return gemerkt;
}

export function zertifikatLinkVergessen(): void {
  gemerkt = null;
}
